import { OpenAPI } from '@hotjar/api-client-engage-insights';
import { parametersStore } from '../utils/parametersStore';
import { IS_PROD } from '../../../constants';

const auth = parametersStore.get('auth');

OpenAPI.BASE = `${OpenAPI.BASE}/engage/api`;
OpenAPI.CREDENTIALS = IS_PROD ? 'include' : 'omit';
OpenAPI.WITH_CREDENTIALS = true;

OpenAPI.HEADERS = {
  ...(auth ? { Authorization: `Bearer ${auth}` } : {}),
};

export function setAuthHeader(auth: string) {
  OpenAPI.HEADERS = {
    ...OpenAPI.HEADERS,
    Authorization: `Bearer ${auth}`,
  };
}

export { thankYouDetailsMock, useThankYouDetails, useThankYouDetailsPrefetch } from './thank-you';

export { projectDetailsMock, useProjectDetailsQuery, getProjectDetailsCached } from './project';
